import { FC } from "react";
import { formStyles } from "shared/ui";
import { PlayIcon } from "shared/ui/icons";
import { useDrawRaffle } from "../model/useDrawRaffle";

import styles from "./DrawRaffleButton.module.css";

interface Props {
  raffleId: number;
  onDrawn?: () => void;
}

const BUTTON_CLASS = `${formStyles.outlineButton} ${formStyles.accent}`;

// Розыгрыш необратим, поэтому сначала спрашиваем подтверждение.
export const DrawRaffleButton: FC<Props> = ({ raffleId, onDrawn }) => {
  const draw = useDrawRaffle(raffleId, onDrawn);

  if (!draw.isConfirming) {
    return (
      <button
        type="button"
        className={styles.start}
        onClick={draw.startConfirm}
      >
        <PlayIcon width={24} height={24} />
        Start
      </button>
    );
  }

  return (
    <div className={styles.confirm}>
      <span className={styles.question}>
        End the promo now and draw the prizes? This can&apos;t be undone.
      </span>
      <div className={styles.actions}>
        <button
          type="button"
          className={formStyles.outlineButton}
          disabled={draw.isDrawing}
          onClick={draw.cancelConfirm}
        >
          Cancel
        </button>
        <button
          type="button"
          className={BUTTON_CLASS}
          disabled={draw.isDrawing}
          onClick={draw.confirm}
        >
          {draw.isDrawing ? "Drawing..." : "Draw"}
        </button>
      </div>
      {draw.errorMessage && (
        <p className={formStyles.error}>{draw.errorMessage}</p>
      )}
    </div>
  );
};
